import { render, staticRenderFns } from "./IconMailMove.vue?vue&type=template&id=294be031&"
var script = {}
import style0 from "./IconMailMove.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('294be031')) {
      api.createRecord('294be031', component.options)
    } else {
      api.reload('294be031', component.options)
    }
    module.hot.accept("./IconMailMove.vue?vue&type=template&id=294be031&", function () {
      api.rerender('294be031', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/icons/IconMailMove.vue"
export default component.exports